import { transparentize } from '@chakra-ui/theme-tools';

/**
 * Given that this multipart refers to a component with multiple parts, you need to define the parts in a part key:
 */

var parts = ['indicator', 'track', 'icon'];
var strokeWidth = '8px';
/**
 * The base styles for the circular progress track, indicator and icon
 */

var baseStyle = function baseStyle(props) {
  var value = props.value,
    _props$max = props.max,
    max = _props$max === void 0 ? 100 : _props$max;
  return {
    indicator: {
      stroke: value >= max ? 'green.400' : 'yellow.400',
      strokeWidth: strokeWidth,
      strokeLinecap: 'round'
    },
    track: {
      stroke: transparentize('gray.300', 0.5),
      strokeWidth: strokeWidth
    },
    icon: {
      position: 'absolute',
      top: 0,
      left: 0,
      p: '12%',
      borderRadius: 'full'
    }
  };
};
var CircularProgress = {
  parts: parts,
  baseStyle: baseStyle
};
export { CircularProgress as default };